module.exports = __webpack_public_path__ + "static/img/背景.bc8eddc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/背景.png
// module id = lQ97
// module chunks = 12